<div class="form-group">
    <textarea class="form-control"
              name="content"
              rows="4"
              cols="50"
              value="{{fieldOptions.html}}"
              [(ngModel)]="fieldOptions.html"></textarea>
</div>